<template>
  <div class="m-15">
    <b-row>
      <b-col xl="12" md="12" lg="12" sm="12" class="mt-3">
        <b-card header-tag="header" style="font-weigth=fsbold">
          <template slot="header">
            <b-row>
              <b-col cols="12">
                <h5 class="float-center">
                  <strong>Configurações</strong>
                </h5>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col cols="12" lg="6" class="mt-3">
              <table>
                <tbody>
                  <tr>
                    <td class="mw67">
                      <c-switch
                        id="HavePush"
                        class="mx-1"
                        v-model="havePush"
                        color="success"
                        checked
                        variant="3d"
                        @change="onChangePush()"
                      />
                    </td>
                    <td>
                      <span>
                        &nbsp;
                        <strong>Enviar push</strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-input-group prepend="Título" v-if="havePush">
                <b-form-input
                  id="Titulo"
                  v-model="titulo"
                  autofocus
                  placeholder="ex: Promoção - Item com 10% de desconto"
                  @keyup.enter="onChanged('Descricao')"
                />
              </b-input-group>

              <b-input-group prepend="Descrição" class="mt-3" v-if="havePush">
                <b-form-input
                  id="Descricao"
                  v-model="descricao"
                  placeholder="ex: Válido por X dias"
                  @keyup.enter="onChanged('DataInicial')"
                  @keyup.esc="onChanged('Titulo')"
                />
              </b-input-group>
            </b-col>

            <b-col cols="12" lg="6" class="mt-5" style="padding: 6px">
              <b-input-group prepend="Data Inicial">
                <b-form-input
                  type="date"
                  id="DataInicial"
                  v-model="dataInicial"
                  @change="onChanged('DataFinal')"
                  @keyup.enter="onChanged('DataFinal')"
                  @keyup.esc="onChanged('Descricao')"
                />
              </b-input-group>

              <b-input-group prepend="Data Final" class="mt-3">
                <b-form-input
                  type="date"
                  id="DataFinal"
                  v-model="dataFinal"
                  @change="onChanged('DataFinal')"
                  @keyup.esc="onChanged('DataInicial')"
                />
              </b-input-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ptBR } from "vuejs-datepicker/dist/locale";
import { Switch as cSwitch } from "@coreui/vue";

import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";
import store from "../../../store";

export default {
  name: "inserirpromocaoconfiguracoes",
  components: {
    cSwitch,
    Datepicker,
    VueTimepicker,
  },
  data: function () {
    return {
      havePush: false,
      haveEmail: false,
      titulo: "",
      descricao: "",
      showText: false,
      store,
      ptBR: ptBR,
      dataInicial: moment(new Date()).format("YYYY-MM-DD"),
      dataFinal: moment(new Date()).format("YYYY-MM-DD"),
    };
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    setLocalStorage() {
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("dataInicialJornalzinho");
      localStorage.removeItem("dataFinalJornalzinho");

      localStorage.setItem("titulo", this.titulo);
      localStorage.setItem("descricao", this.descricao);
      localStorage.setItem("dataInicialJornalzinho", this.dataInicial);
      localStorage.setItem("dataFinalJornalzinho", this.dataFinal);
    },

    focus(id) {
      document.getElementById(id).focus();
    },

    onChanged(id) {
      this.focus(id);

      if (this.havePush) {
        if (this.titulo != "" && this.descricao != "") {
          this.setLocalStorage();
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      } else {
        if (this.dataInicial && this.dataFinal) {
          this.setLocalStorage();
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      }
    },
    onChangePush() {
      localStorage.setItem("have-push", this.havePush);
    },
  },

  mounted() {
    localStorage.setItem("have-push", false);
    localStorage.setItem("show-text", false);

    this.havePush = false;
    this.haveEmail = false;
    this.showText = false;

    this.onChanged('HavePush')
  },
};
</script>
